import { userService } from "../services/user.services";
import { setAuthItem, clearAuthSession } from './authSession';

const refreshIdToken = async () => {
    
    const response = await userService.RefreshToken();
    if (response?.error === false && response?.data?.success_status === true) {
        setAuthItem('IdToken', response.data.data);
    } else {
        if(response?.message?.response?.status===400){
            setAuthItem('custom-status', 'inactive');
            clearAuthSession();
            window.location.href = '/';
        }
    }
}

export default refreshIdToken;